import React from "react";
import "../admin/style/style-pc.css";
import "../admin/style/style-mob.css";
import img from "../../resources/logo.webp";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { host } from "../../config/Config";

export const Profile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [dateTimeData, setDateTimeData] = React.useState({});
    const [isEducationUser, setIsEducationUser] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    let { appointmentsData } = location.state || {};

    React.useEffect(() => {
        // Check user type from localStorage
        const userType = localStorage.getItem("zajednica-user-type");
        setIsEducationUser(userType === "education");
        setLoading(false);
    }, []);

    React.useEffect(() => {
        fetch(`${host}/api/v1/appointments/available`)
            .then((response) => response.json())
            .then((data) => {
                const updatedAppointments = {};

                data.forEach((item) => {
                    const startDate = new Date(item.startTime);
                    const endDate = new Date(item.endTime);

                    const formattedDate = `${startDate
                        .getDate()
                        .toString()
                        .padStart(2, "0")}.${(startDate.getMonth() + 1)
                        .toString()
                        .padStart(2, "0")}.${startDate.getFullYear()}.`;

                    const formattedTime =
                        `${startDate.toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                        })} - ` +
                        `${endDate.toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                        })}`;

                    if (!updatedAppointments[formattedDate]) {
                        updatedAppointments[formattedDate] = [];
                    }
                    updatedAppointments[formattedDate].push(formattedTime);
                });

                setDateTimeData(updatedAppointments);
            })
            .catch((error) =>
                console.error("Error fetching available appointments", error)
            );
    }, [appointmentsData]);

    const GoToVacation = () => {
        navigate("/settings");
    };

    const GoToReservations = () => {
        appointmentsData = dateTimeData;
        navigate("/reservation", {
            state: {
                appointmentsData,
            },
        });
    };

    const GoToAppointments = () => {
        navigate("/my-appointments");
    };

    const GoToAllEducations = () => {
        navigate("/educations");
    };

    const GoToEducations = () => {
        navigate("/my-educations");
    };

    const GoToSettings = () => {
        navigate("/");
    };

    if (loading) {
        return (
            <div className='barber-zajednica-admin-page'>
                <div className='barber-zajednica-admin-background'></div>
                <h1>Učitavanje...</h1>
            </div>
        );
    }

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <h1>Dobrodošao</h1>
            {isEducationUser ? (
                <>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToEducations}
                    >
                        Moje Edukacije
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToAllEducations}
                    >
                        Zakaži Edukaciju
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToVacation}
                    >
                        Promeni Br. Telefona
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToSettings}
                    >
                        Početna strana
                    </button>
                </>
            ) : (
                <>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToReservations}
                    >
                        Rezerviši Termin
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToAppointments}
                    >
                        Pregled mojih termina
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToVacation}
                    >
                        Promeni Br. Telefona
                    </button>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={GoToSettings}
                    >
                        Početna strana
                    </button>
                </>
            )}
            <div
                className='barber-zajednica-admin-logo'
                style={{ width: "300px" }}
            >
                <img src={img} />
            </div>
        </div>
    );
};
